var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typo } from "../../../typography";
import { isSameDay } from "date-fns";
import { useTheme } from "styled-components";
import { DayButtonsWrapper, WeekWrapper, StyledButton, StyledButtonWrapper, Appointment, } from "./day.styles";
const isInPast = (date) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return today.getTime() - date.getTime() > 0;
};
const emptyDate = (_jsx("div", { style: {
        display: "inline-block",
        width: "2.5rem",
        border: "none",
        background: "transparent",
    } }));
export function Days(_a) {
    var { calendar, isInRange } = _a, rest = __rest(_a, ["calendar", "isInRange"]);
    return (_jsx(DayButtonsWrapper, { children: calendar.weeks.map((week, weekIndex) => {
            const weekDays = week.map((dateObj, index) => {
                const key = `${calendar.month}${calendar.year}${weekIndex}${index}`;
                if (!dateObj) {
                    return emptyDate;
                }
                const { date } = dateObj;
                const inRange = isInRange ? isInRange(date) : false;
                return (_jsx(CalendarDate, Object.assign({ inRange: inRange, dateObj: dateObj }, rest), key));
            });
            return (_jsx(WeekWrapper, { children: weekDays }, `${calendar.month}${calendar.year}${weekIndex}`));
        }) }));
}
function CalendarDate({ dateObj, inRange, hoveredDate, selected: selectedDates = [], onSelect, getDateProps, appointments = [], }) {
    const theme = useTheme();
    const { date, selected, selectable, today, nextMonth, prevMonth } = dateObj;
    return (_jsxs(StyledButtonWrapper, Object.assign({ isInRange: inRange, selected: selected, paddingRight: hoveredDate && date.getTime() < hoveredDate.getTime(), paddingBoth: selectedDates[1] &&
            date.getTime() === selectedDates[1].getTime() &&
            hoveredDate &&
            selectedDates[1].getTime() !== hoveredDate.getTime(), today: today }, { children: [_jsxs(StyledButton, Object.assign({ onMouseEnter: () => {
                    if (typeof onSelect === "function")
                        onSelect(date);
                }, thisMonth: !nextMonth && !prevMonth, disabled: !selectable, today: today, selected: selected, isInPast: isInPast(date), stylingType: "icon", isIcon: true, rounded: true, isInRange: inRange }, getDateProps({ dateObj }), { children: [appointments.some((d) => isSameDay(d, date)) && _jsx(Appointment, {}), _jsx(Typo, Object.assign({ fontWeight: theme.fontWeights.regular, variant: "p2" }, { children: date.getDate() }))] })), _jsx("span", { className: "range-selection" })] })));
}
